import { render, staticRenderFns } from "./ClaimSuccess.vue?vue&type=template&id=6e70c891&scoped=true&"
import script from "./ClaimSuccess.vue?vue&type=script&lang=js&"
export * from "./ClaimSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ClaimSuccess.vue?vue&type=style&index=0&id=6e70c891&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e70c891",
  null
  
)

export default component.exports